import { UseFormHandleSubmit, UseFormReset } from "react-hook-form";
import { usePriceListState } from "atoms/priceListAtom";

import { Button, EButtonVariant } from "components/Button/Button";

import { FormOptValues } from "./Opt";
import { useAddPriceListItem, useEditPriceListItem } from "./api";

type Props = {
  onSubmit: UseFormHandleSubmit<any>;
  reset: UseFormReset<any>;
};

export const OptFooter = ({ onSubmit, reset }: Props): JSX.Element => {
  const { mutate: addPriceList } = useAddPriceListItem();
  const { mutate: editPriceList } = useEditPriceListItem();
  const { priceListState } = usePriceListState();

  const handleClick = (data: FormOptValues) => {
    /*    if (priceListState.activeItem?.pricelistid) {
      alert("Вы не можете редактировать данные прайс-листа.");
      return;
    }*/

    const { name } = data;

    if (!name) return;

    if (priceListState.activeItem?.pricelistid) {
      editPriceList(
        {
          name,
          pricelistid: priceListState.activeItem.pricelistid,
        },
        {
          onSuccess: () => {
            reset({ name: "", id: "" });
          },
        }
      );
    } else {
      addPriceList(
        { name },
        {
          onSuccess: () => {
            reset({ name: "", id: "" });
          },
        }
      );
    }
  };

  return (
    <div className="flex flex-row ">
      <Button
        icon="galochka"
        variant={EButtonVariant.SECONDARY}
        onClick={onSubmit(handleClick)}
      >
        Сохранить
      </Button>
    </div>
  );
};
